import { render, staticRenderFns } from "./AssessmentScoreOffLine.vue?vue&type=template&id=12162333&scoped=true"
import script from "./AssessmentScoreOffLine.vue?vue&type=script&lang=js"
export * from "./AssessmentScoreOffLine.vue?vue&type=script&lang=js"
import style0 from "./AssessmentScoreOffLine.vue?vue&type=style&index=0&id=12162333&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12162333",
  null
  
)

export default component.exports